import { url } from './urls';

export const buttons = {
  toggleBlue: `${url.CDN_URL}/buttons/toggle-blue.png`,
  toggleRed: `${url.CDN_URL}/buttons/red-toggle.png`,
  toggleGray: `${url.CDN_URL}/buttons/toggle-gray.png`,
  checkIcon: `${url.CDN_URL}/buttons/check-toggle-icon.png`,
};

export const icons = {
  powerIcon:
    'https://mint-exp.s3.eu-central-1.amazonaws.com/fab/assets/general/icons/power-icon.webp',
  chevronDown: `${url.CDN_URL}/icons/chevron-down.svg`,
  chevronDownYellow: `${url.CDN_URL}/icons/chevron-down-yellow.svg`,
  accountIcon: 'https://mint-exp.s3.eu-central-1.amazonaws.com/icons/account.svg',
  arrowLeftIcon: 'https://mint-exp.s3.eu-central-1.amazonaws.com/icons/arrow-left.svg',
  loaderIcon: 'https://mint-exp.s3.eu-central-1.amazonaws.com/icons/loader.svg',
};

export const general = {
  appStore: `${url.CDN_URL}/general/app-store.png`,
  arrowDown: `${url.CDN_URL}/general/arrow-down.png`,
  background: `${url.CDN_URL}/general/background.png`,
  fabLogoWhite: `${url.CDN_URL}/general/fab-logo-white.svg`,
  fabWebshopNavbarLogo: `${url.CDN_URL}/general/fab-webshop-navbar-logo.png`,
  pictoiconHourglass: `${url.CDN_URL}/general/pictoicon-hourglass.png`,
  userIcon: `${url.CDN_URL}/icons/profile-icon.png`,
};

export const flags = {
  enFlag: 'https://mint-exp.s3.eu-central-1.amazonaws.com/fab/assets/general/icons/en-language-icon.png',
  koFlag: 'https://mint-exp.s3.eu-central-1.amazonaws.com/fab/assets/general/icons/ko-language-icon.png',
};
